import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, {useMemo} from 'react';
import { useQuery } from 'react-apollo';

import { Button, Card } from "react-bootstrap";
import { Definition } from '../data/Definition';
import { IDwCrossFilter } from '../data/Query';
import { GET_DATA_DEFINITIONS } from '../queries';
import '../styles/Filter.scss';
import { capitalizeFirstLetter, isInt } from '../utils';


type CrossFilterProps = {
    filter: IDwCrossFilter,
    onRemoveFilter: (filter: IDwCrossFilter) => void
};

const arrayText = (values: any) => {
    if(values.length > 2) {
        return `${formattedNumberText(values[0])}, ${formattedNumberText(values[1])}, and ${values.length-2} more`;
    } else if(values.length === 2) {
        return `${formattedNumberText(values[0])} and ${formattedNumberText(values[1])}`;
    }

    return values;
}

const formattedNumberText = (value: string | number) => {
    if(typeof value == "string") {
        return value;
    } else {
        return isInt(value) ? value : value.toFixed(2);
    }
}


const CrossFilter = ({ filter, onRemoveFilter}: CrossFilterProps) => {
    const {data, loading} = useQuery(GET_DATA_DEFINITIONS);

    const getFilterName = (filter: IDwCrossFilter): string => {
        return filter.filter.type === 'geojson' ? getSpatialFilterDesc(filter) : getDataFilterDesc(filter);
    }

    const getFilterValue = (filter: IDwCrossFilter): string => {
        return filter.filter.type === 'geojson' ? getSpatialFilterValue(filter) : getDataFilterValue(filter);
    }

    const getDataFilterDesc = (filter: IDwCrossFilter) => {
        const dataDefinition = data.syncarto_app_data_definition.find((d: any) => d.id === filter.definitionId);
        const definition: Definition = dataDefinition.definition;

        const parts = filter.filter.id.split(':');
        const dataPath = parts[1];
        const propId = parseInt(dataPath.replace(/[^0-9]/g,''));

        if(!propId) { 
            return `${capitalizeFirstLetter(dataPath)} ID`;
        } else {
            const subPropName = dataPath.replace(/[0-9]/g,'');
            const property = definition.property.find((p: any) => p.id === propId);

            if(property) {
                return subPropName ? `${property.name} ${subPropName}` : property.name;
            }

            return 'unknown';
        }
    }

    const getSpatialFilterDesc = (filter: IDwCrossFilter) => {
        return 'Spatial';
    }

    const getDataFilterValue = (filter: IDwCrossFilter) => {
        return Array.isArray(filter.filter.value) ? arrayText(filter.filter.value) : formattedNumberText(filter.filter.value);
    };

    const getSpatialFilterValue = (filter: IDwCrossFilter) => {
        return 'AOI';
    }

    const description: string = useMemo(() => {
        if(loading) {
            return 'loading...';
        }

        return `${getFilterName(filter)} ${filter.filter.operation} ${getFilterValue(filter)}`;
    }, [filter, data]); 

    return (
        <Card style={{marginBottom: '7px'}}>
          <Card.Body className="px-3 py-2">    
              <div>{filter.widgetInstanceTitle.toUpperCase()}</div>
              {
                  filter.bySelection && 
                  <Button variant="link" title="Remove filter" onClick={(e: any) => e.preventDefault()}>
                      <FontAwesomeIcon icon={faTimes} onClick={(e: any) => onRemoveFilter(filter)} />
                  </Button>
              }    
          </Card.Body>
          <Card.Footer>
              <small style={{paddingRight: '15px'}}>
                  {description}
              </small>   
          </Card.Footer>
      </Card>
    );
}

export default CrossFilter;
